/* Landing page szkolenia (sekcje lp-*). Plik dołączają różne sekcje, więc inicjujemy go tylko raz. */
(function () {
  if (window.__lpInit) return;
  window.__lpInit = true;

  var GENERIC_ERROR = 'Nie udało się dodać szkolenia do koszyka. Spróbuj ponownie albo zadzwoń do nas.';

  function track(name, data, custom) {
    if (typeof window.fbq === 'function') window.fbq(custom ? 'trackCustom' : 'track', name, data || {});
  }

  // Pixel wysyła zdarzenie obrazkiem; natychmiastowe przejście na inną stronę przerywa to zapytanie
  // (tak ginęły AddToCart/InitiateCheckout przed kasą). Dajemy mu chwilę przed nawigacją.
  function afterTracking(go) {
    if (typeof window.fbq === 'function') setTimeout(go, 400);
    else go();
  }

  /* ---------- Program: zakładki dni (telefon) ---------- */
  function selectTab(tab, focus) {
    var list = tab.closest('[role="tablist"]');
    list.querySelectorAll('[data-lp-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.classList.toggle('is-active', on);
    });
    if (focus) tab.focus();
  }

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-lp-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[data-lp-tab]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    selectTab(tabs[(i + tabs.length) % tabs.length], true);
    e.preventDefault();
  });

  /* ---------- Zapisy: liczba uczestników ---------- */
  function clampQty(input) {
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || min;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    v = Math.min(Math.max(v, min), max);
    input.value = v;
    var root = input.closest('[data-lp-buy]');
    root.querySelector('[data-lp-qty="-1"]').disabled = v <= min;
    root.querySelector('[data-lp-qty="1"]').disabled = v >= max;
    return v;
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-lp-qty-input]')) clampQty(e.target);
  });

  /* ---------- Zapisy: koszyk i kasa ---------- */
  function setLine(variantId, qty) {
    var body = { updates: {} };
    body.updates[variantId] = qty;
    var lac = window.liquidAjaxCart;
    // Przez Liquid Ajax Cart, żeby drawer i jego stan koszyka od razu znały nową ilość.
    if (lac && lac.init && typeof lac.update === 'function') {
      return new Promise(function (resolve, reject) {
        lac.update(body, {
          lastCallback: function (state) {
            var res = state && state.responseData;
            if (res && res.ok) resolve(res.body);
            else reject(new Error((res && res.body && (res.body.description || res.body.message)) || ''));
          }
        });
      });
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (b) {
        if (!r.ok) throw new Error(b.description || b.message || '');
        return b;
      });
    });
  }

  // Przycisk kasy z drawera motywu uruchamia te same kroki co zwykły koszyk:
  // minimum pierwszego zamówienia, prezent dla nowego klienta, okno z danymi do faktury.
  function goCheckout() {
    var btn = document.querySelector('#b2b-cart-drawer [data-checkout-btn]');
    if (btn) btn.click();
    else window.location.href = '/checkout';
  }

  function buy(root, button) {
    var variantId = parseInt(root.dataset.variantId, 10);
    var input = root.querySelector('[data-lp-qty-input]');
    var error = root.querySelector('[data-lp-error]');
    if (!variantId || !input) return;
    var qty = clampQty(input);
    var value = (parseInt(root.dataset.price, 10) || 0) * qty / 100;
    var data = {
      content_ids: [String(variantId)],
      content_name: root.dataset.productTitle,
      content_type: 'product',
      contents: [{ id: String(variantId), quantity: qty }],
      num_items: qty,
      value: value,
      currency: root.dataset.currency
    };

    error.textContent = '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    setLine(variantId, qty)
      .then(function (cart) {
        var line = (cart.items || []).filter(function (item) { return item.variant_id === variantId; })[0];
        if (!line) throw new Error('');
        if (line.quantity < qty) {
          input.max = line.quantity;
          clampQty(input);
          throw new Error('Dostępne miejsca: ' + line.quantity + '. Zmień liczbę uczestników.');
        }
        track('AddToCart', data);
        track('InitiateCheckout', data);
        afterTracking(goCheckout);
      })
      .catch(function (err) {
        error.textContent = (err && err.message) || GENERIC_ERROR;
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  /* ---------- Powrót po zatwierdzeniu konta (snippets/lp-return.liquid) ---------- */
  var RETURN_KEY = 'lp-return';
  function rememberPage(root) {
    try {
      localStorage.setItem(RETURN_KEY, JSON.stringify({ path: location.pathname, title: root.dataset.pageTitle || '', t: Date.now() }));
    } catch (e) {}
  }
  // Zapis sprzed wyłączenia przypomnienia albo już nieaktualny (klient wrócił jako aktywny) usuwamy.
  document.querySelectorAll('[data-lp-buy][data-state="ok"], [data-lp-buy][data-return="false"]').forEach(function (root) {
    try {
      var saved = JSON.parse(localStorage.getItem(RETURN_KEY) || 'null');
      if (saved && saved.path === location.pathname) localStorage.removeItem(RETURN_KEY);
    } catch (e) {}
  });

  /* ---------- FAQ: jak na kartach produktów (faq-product) — jedno otwarte pytanie,
     następne otwiera się po zamknięciu poprzedniego ---------- */
  function setFaq(item, open) {
    item.classList.toggle('is-open', open);
    item.querySelector('[data-lp-faq-btn]').setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function toggleFaq(item) {
    var wasOpen = item.classList.contains('is-open');
    var others = Array.prototype.filter.call(
      item.parentElement.querySelectorAll('[data-lp-faq-item].is-open'),
      function (el) { return el !== item; }
    );
    others.forEach(function (el) { setFaq(el, false); });
    if (wasOpen) return setFaq(item, false);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (others.length && !reduce) setTimeout(function () { setFaq(item, true); }, 350);
    else setFaq(item, true);
  }

  /* ---------- Kliknięcia ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var tab = t.closest('[data-lp-tab]');
    if (tab) return selectTab(tab, false);

    var dot = t.closest('[data-lp-dot]');
    if (dot) {
      scrollToCard(dot.closest('[data-lp-stations]').querySelector('[data-lp-track]'), parseInt(dot.dataset.lpDot, 10));
      return;
    }

    var faqBtn = t.closest('[data-lp-faq-btn]');
    if (faqBtn) return toggleFaq(faqBtn.closest('[data-lp-faq-item]'));

    var step = t.closest('[data-lp-qty]');
    if (step) {
      var input = step.closest('[data-lp-buy]').querySelector('[data-lp-qty-input]');
      input.value = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.lpQty, 10);
      clampQty(input);
      return;
    }

    var buyBtn = t.closest('[data-lp-buy-button]');
    if (buyBtn) {
      var root = buyBtn.closest('[data-lp-buy]');
      if (root.dataset.state === 'ok') return buy(root, buyBtn);
      var dialog = root.querySelector('[data-lp-dialog]');
      if (dialog && !dialog.open) {
        dialog.showModal();
        track('B2BLoginRequired', { content_ids: [String(root.dataset.variantId)] }, true);
      }
      return;
    }

    if (t.closest('[data-lp-dialog-close]') || t.matches('[data-lp-dialog]')) {
      var dlg = t.closest('[data-lp-dialog]');
      if (dlg) dlg.close();
      return;
    }

    var authLink = t.closest('[data-lp-register], [data-lp-login]');
    if (authLink) {
      var buyRoot = authLink.closest('[data-lp-buy]');
      if (buyRoot && buyRoot.dataset.return !== 'false') rememberPage(buyRoot);
      if (authLink.hasAttribute('data-lp-register')) {
        track('Lead', { content_name: buyRoot && buyRoot.dataset.productTitle });
        // Zwykłe kliknięcie: przejście po wysłaniu zdarzenia. Ctrl/środkowy przycisk otwierają kartę jak zwykle.
        if (!e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
          e.preventDefault();
          var href = authLink.href;
          afterTracking(function () { window.location.href = href; });
        }
      }
    }
  });

  /* ---------- Stacje: slider, gdy karty nie mieszczą się w rzędzie ---------- */
  // Pozycja karty w torze (niezależna od paddingu i przewinięcia).
  function cardLeft(track, el) {
    return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
  }

  function setActiveDot(track, index) {
    var dots = track.closest('[data-lp-stations]').querySelectorAll('[data-lp-dot]');
    if (track._lpDot === index) return;
    track._lpDot = index;
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
      if (i === index) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }

  // Aktywna = karta najbliżej lewej krawędzi; na końcu toru zawsze ostatnia.
  function updateDots(track) {
    if (track._lpLocked) return;
    var cards = track.children;
    if (!cards.length) return;
    var index = 0;
    if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) index = cards.length - 1;
    else {
      var best = Infinity;
      Array.prototype.forEach.call(cards, function (card, i) {
        var d = Math.abs(cardLeft(track, card) - cardLeft(track, cards[0]) - track.scrollLeft);
        if (d < best) { best = d; index = i; }
      });
    }
    setActiveDot(track, index);
  }

  function scrollToCard(track, index) {
    var cards = track.children;
    if (!cards[index]) return;
    setActiveDot(track, index);
    // Na czas płynnego przewijania kropki nie śledzą pozycji, inaczej przeskakują po drodze.
    track._lpLocked = true;
    clearTimeout(track._lpUnlock);
    var unlock = function () {
      track._lpLocked = false;
      track.removeEventListener('scrollend', unlock);
      updateDots(track);
    };
    track.addEventListener('scrollend', unlock);
    track._lpUnlock = setTimeout(unlock, 900);
    var max = track.scrollWidth - track.clientWidth;
    track.scrollTo({ left: Math.min(cardLeft(track, cards[index]) - cardLeft(track, cards[0]), max), behavior: 'smooth' });
  }

  function initStations() {
    document.querySelectorAll('[data-lp-stations]').forEach(function (section) {
      var track = section.querySelector('[data-lp-track]');
      if (!track) return;
      section.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 1);
      track._lpDot = null;
      updateDots(track);
    });
  }

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!(track instanceof Element) || !track.matches('[data-lp-track]') || track._lpFrame) return;
    track._lpFrame = requestAnimationFrame(function () {
      track._lpFrame = null;
      updateDots(track);
    });
  }, true);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initStations, 150);
  });

  /* ---------- Pojawianie się sekcji ---------- */
  // Gdy jeden element grupy wejdzie na ekran, pokazujemy całe rodzeństwo .lp-r
  // (opóźnienia --lp-d robią kaskadę), więc karuzela i ukryta zakładka dnia też się odsłaniają.
  var revealer = null;
  function initReveal() {
    var items = document.querySelectorAll('.lp-r:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!revealer) {
      revealer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var parent = entry.target.parentElement;
          Array.prototype.forEach.call(parent.children, function (el) {
            if (!el.classList.contains('lp-r')) return;
            el.classList.add('is-visible');
            revealer.unobserve(el);
          });
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    }
    items.forEach(function (el) { revealer.observe(el); });
  }

  function init() { initReveal(); initStations(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
